module.exports = __webpack_public_path__ + "img/composer.eb720cdf.png";